<template>
  <svg data-v-c278b7b4="" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 21 21" style=""><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M11.5 3.5c1.328 0 2.57.37 3.628 1.012a6 6 0 0 0-.001 11.977A7 7 0 1 1 11.5 3.5"></path></svg>
</template>
<script setup lang="ts">
</script>